import { createApp } from 'vue'
import App from './App.vue'
// import lodash from 'lodash'


createApp(App)
    // .provide('lodash', lodash)
    .mount('#app');

